import React from 'react';
import './WhereToFind.css';

function WhereToFind() {
  return (
    <div className="where-to-find">
      <div className="container">
        <h2 className="page-title">Où me trouver</h2>
        <p className="page-subtitle">
          Découvrez où vous pouvez trouver et acheter mes créations
        </p>

        <div className="locations-container">
          <div className="location-card featured">
            <div className="location-icon">🏪</div>
            <h3 className="location-name">L'Heureux Hasard</h3>
            <p className="location-type">Boutique permanente</p>
            <p className="location-address">
              📍 Trentemoult, France
            </p>
            <p className="location-description">
              Une boutique charmante où vous pourrez découvrir mes créations 
              toute l'année, aux côtés d'autres artisans locaux.
            </p>
            <a 
              href="https://www.instagram.com/lheureuxhasard_trentemoult/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="location-link"
            >
              📱 Suivre sur Instagram
            </a>
          </div>

          <div className="location-card">
            <div className="location-icon">🌸</div>
            <h3 className="location-name">Marchés Printemps</h3>
            <p className="location-type">Mars - Juin</p>
            <p className="location-description">
              Venez me rencontrer sur les marchés locaux au printemps ! 
              C'est l'occasion parfaite pour voir et toucher mes créations, 
              et discuter de vos envies personnalisées.
            </p>
            <div className="season-badge spring">Printemps</div>
          </div>

          <div className="location-card">
            <div className="location-icon">☀️</div>
            <h3 className="location-name">Marchés d'Été</h3>
            <p className="location-type">Juin - Septembre</p>
            <p className="location-description">
              Tout au long de l'été, retrouvez-moi sur différents marchés 
              artisanaux de la région. Une belle opportunité de profiter 
              du soleil et de découvrir mes nouvelles créations estivales.
            </p>
            <div className="season-badge summer">Été</div>
          </div>
        </div>

        <div className="info-section">
          <h3 className="info-title">📅 Calendrier des marchés</h3>
          <p className="info-text">
            Pour connaître les dates et lieux précis de mes prochaines participations 
            aux marchés, n'hésitez pas à me suivre sur les réseaux sociaux ou à me contacter 
            directement. Je mets régulièrement à jour mon calendrier de présence.
          </p>
        </div>

        <div className="contact-section">
          <h3 className="contact-title">💌 Vous souhaitez me contacter ?</h3>
          <p className="contact-text">
            Pour toute question, commande personnalisée ou demande d'information, 
            n'hésitez pas à me joindre. Je serai ravie d'échanger avec vous !
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhereToFind;
